import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './task.reducer'
import * as state from './task.state'
import { Task } from './task.model'
import * as R from 'ramda'
import { selectInquiryEntities } from '@tv3/store/inquiry/inquiry.selectors'
import { isSomething, selectUserEntities, User } from '@tokeet/tv3-platform'

export const taskState = createFeatureSelector<state.State>('task')

export const selectAllTasks = createSelector(taskState, reducer.selectAll)

export const isUpdatingTasks = createSelector(taskState, (state: state.State) => state.isUpdating)

export const selectAllTasksViews = createSelector(
  selectAllTasks,
  selectUserEntities,
  selectInquiryEntities,
  (tasks, userEntities, inquiryEntities) => {
    return R.map((t: Task) => {
      return {
        ...t,
        inquiryView: R.pathOr('', ['guestDetails', 'name'], inquiryEntities[t.inquiryId]),
        userView: R.pathOr('', ['name'], userEntities[t.userId]),
      }
    }, tasks) as Task[]
  }
)

export const selectTasksLoaded = createSelector(taskState, (state: state.State) => state.isLoaded)

export const selectTaskLists = createSelector(selectAllTasksViews, (tasks: Task[]) => {
  return R.pipe(
    R.groupBy((t: Task) => t.list),
    R.mapObjIndexed((value: Task[], key: string) => ({ id: key, name: key, count: value.length })),
    R.values,
    R.sortBy((e) => e.name.toUpperCase())
  )(tasks)
})

export const selectTaskUsers = createSelector(selectAllTasksViews, (tasks: Task[]) => {
  return R.pipe(
    R.groupBy((t: Task) => t.userId),
    R.mapObjIndexed((value: Task[], key: string) => ({ id: key, name: value[0].userView })),
    <any>R.filter((e: User) => isSomething(e.name)),
    R.values,
    R.sortBy((e: User) => e.name)
  )(tasks)
})
